<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div class="grey-box w-100" style="padding-top: 40px;">
      <div class="filter-wrapper">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div class="d-flex flex-row align-items-center">
            <!--          <div class="d-flex flex-row align-items-center flex-wrap pe-3 mt-4">
                        <span class="pe-2 fw-bold">Ulazak u cilj</span>
                        <app-badge [label]="26" badgeClass="badge-s" [badgeColor]="'red'"/>
                      </div>-->
            <div class="w-360 pe-3">
              <app-select formControlName="raceId" [items]="raceListIds" [translatedLabels]="raceListLabels"
                          [label]="'measurements.controlpoints.race'"/>
            </div>
            @if (measurementsPointsView) {
              <div class="w-360 pe-3">
                <app-select formControlName="controlPointType" [items]="waypointIds" [translatedLabels]="waypointLabels"
                            [label]="'measurements.measurement.points'"/>
              </div>
            }
            <div class="mt-4">
              <div class="d-flex flex-column justify-content-center">
                <app-clock/>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row align-items-center">
            <div class="pe-2 mt-4">
              <app-rounded-button [label]="t('measurements.controlpoints.button.add.chip.time')"
                                  [btnClass]="'rounded-button--button-black-solid'" (onClick)="addChipTime()">
                <i class="bi bi-list-ol pe-2"></i>
              </app-rounded-button>
            </div>
            <div class="pe-2 mt-4">
              <app-rounded-button [label]="t('measurements.controlpoints.button.addrow')"
                                  (onClick)="addMeasurementTimeItem()" [btnClass]="'rounded-button--solid'"><i
                class="bi bi-plus-circle pe-2"></i>
              </app-rounded-button>
            </div>
            <div class="pe-2 mt-4">
              <app-rounded-button [label]="t('measurements.controlpoints.button.savetoserver')"
                                  (onClick)="saveToServer()" [isDisabled]="isSaveToServerDisabled()"
                                  [btnClass]="'rounded-button--solid'"><i class="bi bi-plus-circle pe-2"></i>
              </app-rounded-button>
            </div>
          </div>
        </div>
        <div class="text-center fw-bold pb-3 mt-3 d-flex justify-content-end">
          <app-competitor-count  [raceId]="selectedRace?.id" [event]="eventItem" [displayCount]="['withStartNumber', 'started', 'finished', 'disqualified', 'didNotFinished']"/>
        </div>
      </div>

      <div class="table-wrapper d-xl-block d-none">
        <table class="table align-middle header dark-header">
          <thead class="table-header">
          <tr>
            <th scope="col" class="time-column-width">{{t('measurements.controlpoints.time')}}</th>
            <th scope="col" class="start-number-column-width">{{t('measurements.controlpoints.start.number')}}</th>
            @if (measurementsPointsView) {
              <th scope="col" class="control-point-column-width">{{t('measurements.controlpoints.point')}}</th>
            }
            @if (eventItem?.commonStartNumber ?? true) {
              <th scope="col">{{t('measurements.controlpoints.race')}}</th>
            }
            @if (!measurementsPointsView) {
              <th scope="col" class="laps-width">{{t('measurements.controlpoints.lap')}}</th>
            }
            <th scope="col">{{t('measurements.controlpoints.competitor')}}</th>
            @if (measurementsPointsView) {
              <th scope="col" class="penalty-minutes-width">{{t('measurements.controlpoints.penalty.minutes')}}</th>
              <th scope="col" class="penalty-minutes-width">{{t('competitor.table.status')}}</th>
              <th scope="col" class="penalty-minutes-width">{{
                  t('measurements.controlpoints.number.of.controlpoints')
                }}
              </th>
            }
            @if (!measurementsPointsView) {
              <th scope="col" class="lap-passed-column-width">
                @if (showLapDistancePassedColumn) {
                          {{t('measurements.lap.passed.distance')}}
                }
             </th>
            }
            <th class="more-th text-center px-0">
              @if (competitorControlPointTimeItems?.controls && competitorControlPointTimeItems.controls.length > 0) {
                <div class="d-flex justify-content-center gap-3">
                          <span class="header-action" (click)="onRefreshAllMeasurementItem()">
                            <i class="fas fa-edit" [title]="t('measurements.fetch.competitor.all')"></i>
                          </span>
                  <span class="header-action" (click)="onDeleteAllMeasurementItem()">
                            <i class="fas fa-trash-alt" [title]="t('app.common.delete.all')"></i>
                          </span>
                </div>
              }
            </th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
          <ng-container formArrayName="competitorControlPointTimeItems">
            @if (competitorControlPointTimeItems?.controls && competitorControlPointTimeItems.controls.length > 0) {
              @for (item of competitorControlPointTimeItems.controls;track item;let idx = $index) {
                <ng-container [formGroupName]="idx">
                  <tr>
                    <td style="overflow: visible">
                      <app-date-time-input formControlName="time" [displayTime]="true" [displaySeconds]="true"
                                           [minDate]="measurementTimeItemHolders[idx]?.competitor?.startTime"
                                           [displayMilliseconds]="true" [openDropdownUpwards]="true"
                                           [validationActive]="true" [hideErrorMessage]="true" [hideLabel]="true"
                                           [closeOnScroll]="true"/>
                    </td>
                    <td>
                      <div class="d-flex flex-row flex-nowrap gap-1">
                        <app-input type="number" formControlName="startNumber"/>
                      </div>
                    </td>
                    @if (measurementsPointsView) {
                      <td style="overflow: visible">
                        <app-select formControlName="waypointId" [items]="waypointIds"
                                    [translatedLabels]="waypointLabels" [closeOnScroll]="true"/>
                      </td>
                    }
                    <td style="overflow: visible">
                      <app-select formControlName="raceId" [items]="raceListIds" [translatedLabels]="raceListLabels"
                                  [closeOnScroll]="true"/>
                    </td>
                    @if (!measurementsPointsView) {
                      <td>
                        <div class="d-flex flex-row flex-nowrap gap-1">
                          {{measurementTimeItemHolders[idx].lap ?? "-"}}
                        </div>
                      </td>
                    }
                    <td>
                      <div class="d-flex flex-column align-items-start justify-content-center">
                        <div class="d-flex flex-row  text-nowrap">
                          @if (measurementTimeItemHolders[idx]?.competitor) {
                            <small [class.error]="item.invalid"><strong class="text-uppercase text-nowrap">{{
                                measurementTimeItemHolders[idx].competitor?.fullName ?? ""
                              }}</strong>
                              {{
                                measurementTimeItemHolders[idx]?.competitor?.sex ?
                                  ("(" + t(
                                    'app.common.gender.short.' +
                                    measurementTimeItemHolders[idx]?.competitor?.sex) + ")") : ""
                              }}</small>
                            @if (item.invalid) {
                              <i class="bi bi-info-circle info-icon ps-2 error"
                                 ngbTooltip="{{ competitorControlPointTimeItemsErrors[idx] }}" placement="left"></i>
                            } @else if (measurementTimeItemHolders[idx]?.saveResult
                            !== CompetitorSaveControlPointResultStatus.OK) {
                              <i class="bi bi-info-circle info-icon ps-2"
                                 ngbTooltip="{{ measurementTimeItemHolders[idx].errorMessage ?? t('measurements.competitor.control.point.save.error.' +  measurementTimeItemHolders[idx]?.saveResult) }}"
                                 placement="left"></i>
                            } @else if (!measurementTimeItemHolders[idx]?.competitor?.startTime) {
                              <i class="bi bi-info-circle info-icon ps-2"
                                 ngbTooltip="{{ t('measurements.competitor.not.started') }}" placement="left"></i>
                            }
                          } @else {
                            {{"-"}}
                          }
                        </div>
                      </div>
                    </td>
                    @if (measurementsPointsView) {
                      <td>
                        <div class="d-flex flex-row flex-nowrap gap-1">
                          @if (getWaypointType(this.competitorControlPointTimeItems.at(idx)?.get("waypointId")?.value)
                          === WaypointType.FINISH_WAYPOINT) {
                            <app-input type="number" formControlName="penaltyMinutes" [min]="0" [max]="60"
                                       [maxlength]="2"/>
                          } @else {
                            &nbsp;&nbsp;
                          }
                        </div>
                      </td>
                    }
                    @if (measurementsPointsView) {
                      <td style="overflow: visible">
                        <div class="d-flex flex-row flex-nowrap gap-1">
                          @if (getWaypointType(this.competitorControlPointTimeItems.at(idx)?.get("waypointId")?.value)
                          === WaypointType.FINISH_WAYPOINT) {
                            <app-select formControlName="status" [items]="['FIN', 'DSQ', 'DNF']" [hasDefault]="false"
                                        [labels]="['FIN',
                              'DSQ','DNF']" [closeOnScroll]="true"/>
                          } @else {
                            &nbsp;
                          }
                        </div>
                      </td>
                    }
                    @if (measurementsPointsView) {
                      <td>
                        <div class="d-flex flex-row flex-nowrap gap-1">
                          @if (getWaypointType(this.competitorControlPointTimeItems.at(idx)?.get("waypointId")?.value)
                          === WaypointType.FINISH_WAYPOINT) {
                            <app-input type="number" formControlName="checkpoints" [min]="0" [maxlength]="3"/>
                          } @else {
                            &nbsp;&nbsp;
                          }
                        </div>
                      </td>
                    }
                    @if (!measurementsPointsView) {
                    <td>
                      <div class="d-flex flex-row flex-nowrap gap-1">
                        @if (this.competitorControlPointTimeItems.at(idx)?.get("lapDistancePassed")?.enabled) {
                          <app-input type="number" formControlName="lapDistancePassed" [hideErrorMessage]="true"/>
                        }
                     </div>
                    </td>
                    }
                    <td class="more-td text-center text-align" style="height: 65px;">
                      <div class="d-flex justify-content-end gap-1 px-2">
                          <span class="menu-icon actions-button" (click)="onRefreshMeasurementItem(idx)">
                            <i class="fas fa-edit color-black" [title]="t('measurements.fetch.competitor')"></i>
                          </span>
                        <span class="menu-icon actions-button" (click)="onDeleteMeasurementItem(idx)">
                            <i class="fas fa-trash-alt text-danger" [title]="t('app.common.delete')"></i>
                          </span>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              }
            }
            @if (isLoading) {
              <ng-container>
                <tr>
                  <td colspan="7">
                    <app-loader [isLoading]="isLoading"></app-loader>
                  </td>
                </tr>
              </ng-container>
            }
          </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</ng-container>
